import { Injectable} from '@angular/core';
import { GraphKnDataService } from '../../graph-konva/services/graph-kn.data.service';
import { ContractStepModel, ContractWrapperModel } from '../../../models/contract.model';
import { ContractStepNameService } from './contract-step-name.service';
import { ContractDataService } from './contract-data.service';
import { IGraphData } from '../../graph-konva/models/graph-kn.model-interfaces';

@Injectable({
    providedIn: 'root'
})
export class ContractGraphService {
  public graphData: IGraphData = {
    nodes: [],
    edges: [],
  };
  constructor (
    private contractStepNameService:ContractStepNameService,
    private contractDataService:ContractDataService,
    private graphKnDataService:GraphKnDataService,

  ) {}
    prepareGraph(shareGD = false, redraw = true, contractGuid:string, data?: any, roadmap?: ContractStepModel[]): void {
      this.graphData = {
        nodes: [],
        edges: [],
      };
      roadmap? roadmap.map((step: ContractStepModel) => {
        let nodeName = step.name || step.auto_name|| this.contractStepNameService.stepNameGenerator(step)?.stepName||'';
        nodeName = nodeName.length > 45 ? (nodeName.substring(0, 45) + '...') : nodeName;
        this.graphData.nodes.push({
            id:  step.guid ||'',
            label: nodeName,
            nodeType:'contractStep',
            contract_step_data: step,
            dimension:{width:0,height:0},
            position:{x:0,y:0}
        })
        const index = roadmap.indexOf(step) + 1;
        
        if (index>0 && index !== roadmap.length) {
          this.graphData.edges.push({
            id:index.toString(),
            source: roadmap[index-1].guid||'',
            target: roadmap[index].guid||'',
            points_labels:[]
          });
        }
      }) : null;

      if (shareGD) {
        let projects = this.contractDataService.ContractDataCachedByGuid.get(contractGuid)
        this.graphKnDataService.generateGraphDataContract$.next({
          ...this.graphData,
          state: 'unset',
          projects: projects?.contract?.projects||[],
          redraw: redraw,
          data: data
        })
      }
    }

    subContractPrepareGraphData(step: ContractStepModel,contractGuid:string): void {
        if (step?.target_key) {
            let targetData = this.contractDataService.getCachedStepTargetData(step) as ContractWrapperModel;
            if (targetData && targetData.roadmap_active.steps?.length) {
                this.prepareGraph(false, true, contractGuid, undefined, targetData.roadmap_active.steps);
                this.graphKnDataService.generateGraphDataSubContract$.next({
                    parent_contract_guid: targetData.contract.parent_contract_guid,
                    nodes: this.graphData.nodes,
                    edges: this.graphData.edges,
                    state: targetData.contract.status
                })
            }
        }
    } 
}
